/**
 * Enthält Polyfills um Schrottige Browser auf Trab zu bringen
 */

/**
 * Function.bind is not available in IE8/Android 2.3
 */
if (!Function.prototype.bind) {
  Function.prototype.bind = function(oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP && oThis
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}

/**
 * Promises ist noch ein relativ neues Feature
 */
if ( typeof window.Promise === "undefined" ) {
  window.Promise = require('promise-polyfill');
}

/**
 * Falls der Browser keine Konsole hat
 * Nur für Entwickler-Builds wichtig, in Produktion werden alle console.log durch webpack entfernt.
 */
var method, methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'],
  length = methods.length,
  console = (window.console = window.console || {});
while (length--) {
  method = methods[length];
  (!console[method]) && (console[method] = function() {});
}



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/polyfill.js